




























import Loading from 'vue-loading-overlay';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { OptionalVariableData, OptionalVariableSelect, EventBus, TypeEventBus } from '../utils';
import InfoIcon from './InfoIcon.vue';
@Component({
    components: {
        Loading,
        InfoIcon
    }
})
export default class Summary extends Vue {
    @Prop() data: any;
    @Prop({default: ''}) cardClass: string;
    @Prop({default: 'col-12 col-sm-6 col-md-3 pa-0'}) columnStyles: string
    

    mounted() {}

    get existsSummaryInfo() {
        if (this.data.length > 0) {
            return true;
        }
        return false;
    }
}
